import { render, staticRenderFns } from "./NewAccidentIncidentReport.vue?vue&type=template&id=a89fecc0&scoped=true&"
import script from "./NewAccidentIncidentReport.vue?vue&type=script&lang=js&"
export * from "./NewAccidentIncidentReport.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a89fecc0",
  null
  
)

export default component.exports